export const trackOpticsVideoQueryKeys = {
  all: () => "track-optics-video"
};
